import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
import loginAbout from './login.js';
export default new Vuex.Store({
  modules: {
    loginAbout,
  },
});
